import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a malfunctioning door
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <MalfunctionDoorIcon width={12} />
 */
const MalfunctionDoorIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M17.5 4.16667V15.8333C17.4987 16.275 17.3227 16.6981 17.0104 17.0104C16.6981 17.3227
            16.275 17.4987 15.8333 17.5H4.16667C3.72504 17.4987 3.30189 17.3227 2.98961 17.0104C2.67734
            16.6981 2.50132 16.275 2.5 15.8333V8.33333L8.33333 2.5H15.8333C16.275 2.50132 16.6981 2.67734
            17.0104 2.98961C17.3227 3.30189 17.4987 3.72504 17.5 4.16667ZM15.8333 10H13.3333V10.8333H15.8333V10ZM15
            4.16667H9.16667L8.58333 4.75833L5.66667 7.74167L5.08333 8.33333H15C15.221 8.33333 15.433 8.24554 15.5893
            8.08926C15.7455 7.93297 15.8333 7.72101 15.8333 7.5V5C15.8333 4.77899 15.7455 4.56702 15.5893
            4.41074C15.433 4.25446 15.221 4.16667 15 4.16667Z`}
        />
    </SvgIcon>
)

MalfunctionDoorIcon.defaultProps = defaultProps

export { MalfunctionDoorIcon }
